import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Synonym } from "@/model";
import SynonymRepository from "@/repository/synonymRepository";
import { synonymQueryKeys } from "./keys";


interface DeleteSynonymParams {
    ids?: string[];
    keyword?: string;
}

export const useDeleteSynonyms = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Synonym[], AxiosError, DeleteSynonymParams>({
        mutationKey: ["synonym", "agent", agentId, "delete"],
        mutationFn: async (params: DeleteSynonymParams) => {
            try {
                const res = await SynonymRepository.deleteMany(agentId, params.ids, params.keyword);
                return res.data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: synonymQueryKeys.all(agentId) });
        }
    });
};